<template>
  <div v-loading="globalLoading">
    <div class="empty" v-if="isErrPage">
      <div class="imgErr">
        <img src="../../assets/error/errTip.png" alt="" />
      </div>
      <div class="errTip">面试官未评价</div>
      <div class="tip">
        请完成面试，等待面试官完成评价后，返回该页面查看面试结果
      </div>
      <div class="other" v-if="showOther" style="margin-top: 6px">
        <span class="other-content" @click.stop="jump">
          点击重新参加面试<span class="iconfont-ai" style="font-size: 14px"
            >&#xe631;</span
          >
        </span>
      </div>
    </div>
    <div class="result-content" v-else>
      <div class="main">
        <div :class="['container', isDesktop ? 'container-web' : '']">
          <div class="title">面试结果通知</div>
          <div class="editText" v-html="templateText"></div>
          <div class="other" v-if="showOther">
            <span class="other-content" @click.stop="jump">
              点击重新参加面试<span class="iconfont-ai" style="font-size: 14px"
                >&#xe631;</span
              >
            </span>
          </div>
        </div>
      </div>
      <div class="footer" v-if="candidate.auditStatus === 1">
        <div class="message" v-if="resultMessage">{{ resultMessage }}</div>
        <div :class="['btns', isDesktop ? 'btns-web' : '']" v-else>
          <div class="btn-text">是否同意参加线下面试</div>
          <div class="flex-center">
            <el-button @click.stop="selectDecide(false)">放弃面试</el-button>
            <el-button @click.stop="selectDecide(true)">确认参加</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Agent from "@/lib/common/agent";
import Url from "@/lib/common/url";
import ResultDetails, { ZhuoMuNiao } from "./resultInfo";

export default {
  data() {
    return {
      isErrPage: false,
      candidate: {}, //候选人面试信息
      code: Url.query("c"),
      isDesktop: Agent.isDesktop(),
      globalLoading: true,
      phone: "",
      mapKey: "3MABZ-4G267-QOFXK-P4BJY-KEOJS-7BBD4",
      passText: "已确认参加线下面试，请及时前往面试地点",
      refuseText: "已放弃参加线下面试",
      resultMessage: "",
      startName: "",
      endName: "",
      polylineList: [], // 经纬度坐标点(二维数组)
      result: new ResultDetails(),
      myAmap: null,
      isRepeat: false,
      weixinUrl: "",
      list: []
    };
  },
  computed: {
    showOther: function() {
      const unJump =
        [0, 1, 2, 3].includes(this.candidate.auditStatus) && this.isRepeat;
      if (unJump) this.getWeixin();
      return unJump;
    },
    templateText: function() {
      // 0:待评估，1:通过，2:待定，3:拒绝
      if (this.candidate.auditStatus === 1) {
        return this.parsingTemplate(
          this.candidate.paramList,
          this.result.passTemplate
        );
      }
      if (this.candidate.auditStatus === 2) {
        return this.parsingTemplate(
          this.candidate.paramList,
          this.result.waitTemplate
        );
      }
      if (this.candidate.auditStatus === 3) {
        return this.parsingTemplate(
          this.candidate.paramList,
          this.result.refuseTemplate
        );
      }
      return "";
    }
  },
  mounted() {
    this.getResult();
    this.examRequest();
  },
  methods: {
    // 经纬度
    drawLine(list) {
      const pointList = list;
      for (let i = 2; i < list.length; i++) {
        pointList[i] = Number(list[i - 2]) + Number(list[i] / 1000000);
      }
      this.polylineList = [];
      for (let i = 0; i < pointList.length; i += 2) {
        this.polylineList.push([pointList[i], pointList[i + 1]]);
      }
    },
    // 获取面试结果页模版信息
    async getResult() {
      //  result.exist:false  没有设置结束页模版
      this.result = await ResultDetails.get(this.code);
    },
    //
    async examRequest() {
      try {
        this.candidate = await ResultDetails.getCandidate({
          connectCode: this.code,
          ignoreTidCheck: true
        });
        this.isErrPage = this.candidate.auditStatus === 0;

        if (!this.isErrPage) {
          if (this.candidate.resultData !== "") {
            try {
              // 检查是否存在候选人意向
              const unIntention = JSON.parse(this.candidate.resultData);
              if (unIntention[0] && unIntention[0].value) {
                this.resultMessage =
                  unIntention[0].value === "1"
                    ? this.passText
                    : unIntention[0].value === "2"
                    ? this.refuseText
                    : "";
              }
            } catch (error) {
              console.log("JSON:error", error);
            }
          }
          this.setMainColor();
        }
        this.isRepeatJoin();

        this.globalLoading = false;
      } catch (error) {
        console.log("error:", error);
        this.globalLoading = false;
      }
    },

    // 判断当前面试是否可以重复面试
    async isRepeatJoin() {
      const repeat = await ResultDetails.check(
        this.candidate.connectCode,
        this.candidate.phone
      );
      this.isRepeat = repeat.check ? repeat.canRepeatAnswer === 1 : true;
    },

    // 解析模版
    parsingTemplate(paramList, tem) {
      if (ZhuoMuNiao.isZmn(paramList)) {
        const zmnHome = paramList.find(item =>
          ZhuoMuNiao.judgment(item, ZhuoMuNiao.zmnHomeText)
        );
        if (zmnHome) {
          this.startName = zmnHome.cascadeValue;
        }
        const zmnStore = paramList.find(item =>
          ZhuoMuNiao.judgment(item, ZhuoMuNiao.zmnStoreText)
        );
        if (zmnStore) {
          this.endName = zmnStore.cascadeValue;
          const store = ZhuoMuNiao.zmnJson(zmnStore.value);
          if (store) {
            this.list = store.polyLine;
            // "存在地图"
            const mapInfo = ZhuoMuNiao.getListMap(tem, {
              useTime: store.useTime,
              useDistance: store.useDistance
            });
            tem = mapInfo.template;
            tem = ZhuoMuNiao.getListStoreName(tem, store.value);
            tem = ZhuoMuNiao.getListStoreAddress(tem, store.storeAddress);
            tem = ZhuoMuNiao.getListReceiverName(tem, store.storeManager);
            tem = ZhuoMuNiao.getListReceiverPhone(tem, store.storeManagerPhone);
            tem = ZhuoMuNiao.getListReceiverTime(tem, store.interviewTime);
            if (store.storeManagerPhone) {
              this.phone = store.storeManagerPhone;
              this.$nextTick(() => {
                const tellList = document.querySelectorAll(".tell");
                tellList.forEach(tell => {
                  this.openTell(tell);
                });
              });
            }
            mapInfo.mapList.forEach((item, i) => {
              this.$nextTick(() => {
                this.getQqMap(i);
              });
            });
          } else {
            ZhuoMuNiao.tagList.forEach(item => {
              tem = tem.replace(RegExp(`{${item.name}}`, "g"), "");
            });
          }
        }
      }
      const list = ZhuoMuNiao.tagListFilter(paramList);
      const str = list.reduce((targetTem, currentItem) => {
        targetTem = targetTem.replace(
          RegExp(
            // 防止类似{123}存在，生成/{123}/g报错
            `({)${currentItem.name
              .replace(/{/g, "({)")
              .replace(/}/g, "(})")}(})`,
            "g"
          ),
          currentItem.value
        );
        return targetTem;
      }, tem);

      // 图片大小适应
      this.setloginImg();

      return str;
    },
    setloginImg() {
      this.$nextTick(() => {
        const imgList = document.querySelectorAll("img");
        if (imgList && imgList.length > 0) {
          // 当前手机有效屏宽为，实际屏宽 - 内边距（20*2）；PC有效屏宽600px
          const clientWidth = this.isDesktop
            ? 600
            : document.body.clientWidth - 40;
          imgList.forEach(img => {
            img.style.zoom = clientWidth / img.width;
            img.style["border-radius"] = `${8 / img.style.zoom}px`;
          });
        }
      });
    },
    // 加载腾讯地图资源
    getQqMap(idIndex) {
      const map = document.getElementById("QqMap");
      if (!map && !window.TMap) {
        //创建script标签
        const script = document.createElement("script");
        script.id = "QqMap";
        //设置标签的type属性
        script.type = "text/javascript";
        //设置标签的链接地址  &callback=init
        script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${this.mapKey}&libraries=geometry`;
        //添加标签到dom
        document.body.appendChild(script);
        script.addEventListener("load", () => {
          this.drawLine(this.list);
          this.polylineList = this.polylineList.map(pointList =>
            this.convert(pointList)
          );
          this.initMap(idIndex);
        });
      } else {
        map.addEventListener("load", () => {
          this.initMap(idIndex);
        });
      }
    },
    initMap(idIndex) {
      const mapc = document.querySelector(`.mapC${idIndex}`);
      const loadingMapC = this.$loading({
        target: mapc,
        lock: false,
        text: "Loading",
        spinner: "el-icon-loading",
        customClass: "mapLoadZ-index",
        background: "rgba(0, 0, 0, 0.7)"
      });
      // 定义map变量，调用 TMap.Map() 构造函数创建地图  this.myAmap
      const map = new window.TMap.Map(`container${idIndex}`, {
        center: this.polylineList[0], // 设置地图中心点坐标
        zoom: 15, // 设置地图缩放级别
        pitch: 20, // 设置俯仰角
        showControl: false,
        rotation: 0 // 设置地图旋转角度
      });

      // 创建 MultiPolyline
      this.foundPolyline(map);
      // 计算路径的实际距离
      // this.pathNumber = window.TMap.geometry.computeDistance(this.polylineList);
      // this.loading = false;

      this.$nextTick(() => {
        const toMapList = document.querySelectorAll(".toMap");
        toMapList.forEach(toMap => {
          toMap.addEventListener("click", this.toWebAMap);
        });
        loadingMapC.close();
      });
    },
    // 创建路径线路
    foundPolyline(map) {
      new window.TMap.MultiPolyline({
        id: "polyline-layer", //图层唯一标识
        map: map, //设置折线图层显示到哪个地图实例中
        //折线样式定义
        styles: {
          style_blue: new window.TMap.PolylineStyle({
            color: "#3777FF", //线填充色
            width: 6, //折线宽度
            borderWidth: 2, //边线宽度
            borderColor: "#FFF", //边线颜色
            lineCap: "round" //线端头方式
          })
        },
        //折线数据定义
        geometries: [
          {
            //第1条线
            id: "pl_1", //折线唯一标识，删除时使用
            styleId: "style_blue", //绑定样式名
            paths: this.polylineList
          }
        ]
      });
    },
    async customConfirm(
      messageList = ["内容文本"],
      config = { okText: "确认", noText: "取消" }
    ) {
      const h = this.$createElement;
      const newDatas = messageList.map(item =>
        h("p", { class: "showTitle" }, item)
      );
      try {
        const result = await this.$confirm("", {
          confirmButtonText: config.okText,
          cancelButtonText: config.noText,
          customClass: "confirmClass",
          showClose: false,
          message: h("div", null, newDatas),
          center: true
        });
        return result;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    selectDecide(option) {
      if (!option) {
        this.customConfirm(["放弃参加线下面试？"], { okText: "放弃" })
          .then(() => {
            this.resultMessage = this.refuseText;
            this.save(false);
          })
          .catch(() => {
            // console.log("二次确认catch");
          });
      } else {
        this.resultMessage = this.passText;
        this.save();
      }
    },
    openTell(tell) {
      tell.addEventListener("click", () => {
        this.customConfirm(["点击拨打", +tell.innerText], {
          okText: "拨打"
        }).then(() => {
          window.location.href = `tel://${+tell.innerText}`;
        });
      });
    },
    // 经纬度标准化
    convert(list) {
      return new window.TMap.LatLng(list[0], list[1]);
    },
    jump() {
      window.location.href = this.weixinUrl;
    },
    getWeixin() {
      ResultDetails.getMobileUrl(this.code)
        .then(urlRes => {
          this.weixinUrl = urlRes.data.url;
        })
        .catch(err => {
          console.log(err);
        });
    },
    toWebAMap() {
      const startPoint = this.polylineList[0];
      const endPoint = this.polylineList[this.polylineList.length - 1];
      const start = `from=${this.startName}&fromcoord=${startPoint[0]},${startPoint[1]}`;
      const end = `to=${this.endName}&tocoord=${endPoint[0]},${endPoint[1]}`;
      const url = `https://apis.map.qq.com/uri/v1/routeplan?type=bus&${start}&${end}&policy=1&referer=${this.mapKey}`;
      window.open(url);
    },
    // 设置主题色
    async setMainColor() {
      const mainColor = await ResultDetails.getMainColor();
      document.body.style.setProperty("--resultColor", mainColor || "#525fff");
    },
    // 保存候选人的面试模版页收集信息
    save(isOk = true) {
      const resultData = {
        key: "isJoinOffline",
        name: "是否参加线下面试",
        passStatus: "0",
        value: isOk ? "1" : "2"
      };
      try {
        const extraData = JSON.parse(this.result.extraData);
        resultData.passStatus =
          (extraData[0] && extraData[0].passStatus) || "0";
      } catch (error) {
        console.log("error:", error);
      }
      const params = {
        connectCode: this.code,
        resultData: JSON.stringify([resultData])
      };

      ResultDetails.save(params).then(() => {
        if (this.candidate.outLinkStatus === 1) {
          ResultDetails.tryCallback(this.code);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.result-content {
  height: 100%;
}
::v-deep .tip {
  text-align: left;
  margin: 6px 0;
  font-size: 12px;
  font-family: var(--font);
  font-weight: 400;
  color: #666666;
  line-height: 18px;
}
.main {
  border-top: var(--line);
  padding: 0 20px;
  // overflow: auto;
  .container {
    &-web {
      width: 600px;
      margin: 0 auto;
      .title {
        margin-top: 60px;
        height: 32px;
        font-size: 24px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #111111;
        line-height: 32px;
      }
    }
  }
  .editText {
    margin-bottom: 12px;
    &::v-deep {
      img {
        // max-width: 100%;
        // width: 100%;
        // max-height: 20vh;
        // display: block;
        // margin-bottom: 12px;
        background: #000;
        border-radius: var(--radius-h5);
        object-fit: cover;
        background-clip: content-box;
      }
      .tell {
        outline: rgb(56, 56, 222);
        display: inline-block;
        outline-width: 2px;
        cursor: pointer;
      }
    }
  }
  &::v-deep .map {
    text-align: center;
    // margin-bottom: 36px;
    .map-footer {
      height: 40px;
      background: #f0f0f0;
      border-radius: 40px;
      line-height: 40px;
    }
    .toMap {
      text-align: center;
      display: block;
      font-size: 14px;
      font-family: var(--font);
      font-weight: 400;
      color: #111111;
      cursor: pointer;
    }
    .container {
      canvas {
        border-radius: var(--radius-h5);
      }
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.footer {
  border-top: var(--line);
  width: 100%;
  height: auto;
  background: #fff;
  position: sticky;
  position: -webkit-sticky;
  bottom: 0;
  z-index: 1000;
  .message {
    padding: 16px 63px;
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #666666;
    line-height: 26px;
    text-align: center;
  }
  .btns {
    &-web {
      width: 600px;
      margin: 0 auto;
      padding-bottom: 24px;
    }
    padding: 12px 20px 10px;
    .btn-text {
      text-align: center;
      height: 20px;
      font-size: 14px;
      font-family: var(--font);
      font-weight: 400;
      color: #111111;
      line-height: 16px;
      margin-bottom: 12px;
    }
    &::v-deep {
      .el-button {
        max-height: 5vh;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 46px;
        box-sizing: content-box;
        background: #eceff5;
        width: 50%;
        border: none;
        border-radius: var(--radius-h5);
        span {
          font-size: 18px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #111111;
          line-height: 26px;
        }
        &:last-child {
          background: var(--resultColor);
          span {
            color: #fff;
          }
        }
      }
    }
  }
}
.title {
  margin: 20px auto 12px;
  text-align: center;
  height: 26px;
  font-size: 18px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #111111;
  line-height: 26px;
}
.other {
  padding: 0 0 24px;
  text-align: center;
  .other-content {
    display: inline-block;
    height: 22px;
    font-size: 14px;
    font-family: var(--font);
    font-weight: 400;
    color: #111111;
    line-height: 22px;
    cursor: pointer;
  }
}
.empty {
  height: 100%;
  width: 100%;
  border-top: var(--line);
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding-top: 150px;
  .imgErr {
    width: 35%;
    max-width: 132px;
    margin-bottom: 16px;
    img {
      width: 100%;
    }
  }
  .errTip {
    height: 26px;
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #111111;
    line-height: 26px;
    margin-bottom: 6px;
  }
  .tip {
    padding: 0 66px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #111111;
    line-height: 22px;
    text-align: center;
  }
}
</style>

<style lang="scss">
body {
  --resultColor: #525fff;
  --line: 1px solid rgba(0, 0, 0, 0.1);
  --font: PingFang SC-Regular, PingFang SC;
  --radius-h5: 8px;
}
.el-popup-parent--hidden {
  .v-modal {
    z-index: 1001 !important;
  }
}
.confirmClass {
  width: 327px;
  height: 160px;
  padding: 0 !important;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border-radius: 12px;
  .el-message-box__header {
    display: none;
    padding: 0;
    margin: 0;
  }
  .el-message-box__content {
    width: 100%;
    height: 105px;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-message-box__btns {
    border-top: var(--line);
    width: 100%;
    height: 56px;
    padding: 0;
    margin: 0;
    display: flex;
    .el-button {
      margin: 0 !important;
      padding: 0 !important;
      width: 50%;
      border: none !important;
      &:last-child {
        background: #fff;
        border-left: var(--line) !important;
        span {
          color: var(--resultColor) !important;
        }
      }
      span {
        height: 22px;
        font-size: 16px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #111111;
        line-height: 19px;
      }
    }
  }
  .showTitle {
    height: 26px;
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #111111;
    line-height: 26px;
    &:last-child {
      color: var(--resultColor);
    }
    &:first-child {
      color: #111111 !important;
    }
  }
}
.mapLoadZ-index {
  z-index: 1000;
}
</style>
